var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticeWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000426551 4.55727C-0.0715688 -0.471908 8.99287 -2.48358 10 4.55727C10 9.58645 1.00756 11.67 0.000426551 4.55727Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45551 3.18503C4.55874 3.84371 4.58564 4.05096 4.58564 4.05096C4.64669 4.52088 4.66216 4.76266 4.83486 4.85303C4.92382 4.89962 5.0411 4.89922 5.12705 4.85343C5.21501 4.80644 5.28168 4.70603 5.34072 4.19274C5.3853 3.80436 5.37366 3.63165 5.42226 3.09506C5.43169 2.99184 5.43089 3.01111 5.44254 2.8838C5.49535 2.30343 5.52046 2.01104 5.45941 1.90461C5.31221 1.64796 4.89089 1.51381 4.6232 1.65077C4.48604 1.72105 4.42138 1.84596 4.38623 1.91625C4.24225 2.20423 4.33683 2.42794 4.45551 3.18503Z",
    fill: "#1A3668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91449 6.23128C5.93608 6.46629 5.87123 6.70101 5.72018 6.8868C5.57635 7.07261 5.36767 7.19531 5.13033 7.22948C4.90006 7.26364 4.65549 7.20664 4.46848 7.07032C4.27425 6.93399 4.13756 6.72874 4.09438 6.49711C4.07279 6.26211 4.13756 6.02746 4.28861 5.84159C4.43245 5.6558 4.64113 5.53308 4.87846 5.49896C5.10873 5.46476 5.34615 5.52173 5.54039 5.6581C5.73462 5.79446 5.87123 5.99965 5.91449 6.23128Z",
    fill: "#1A3668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeWarningIcon);
export default __webpack_public_path__ + "static/media/notice-warning-icon.ba78ff2b8332e58daa65a0b1ee5a9f26.svg";
export { ForwardRef as ReactComponent };